import { PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'
import qs from 'qs'

const { get, post, del } = createClient()

/* API request to get collections for game */
export async function getCollectionsForGameRequest(query) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections${queryString(query)}`
  )

  return data
}

/* API request to get collection */
export async function getCollectionRequest(collectionNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}`
  )
  return data
}

/* API request to get collection mods */
export async function getAllCollectionModsRequest(collectionNameId, query) {
  return requestAll(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/mods`,
    query
  )
}

/* API request to follow a collection */
export async function followCollectionRequest(collectionNameId, collectionId) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/followers`,
    qs.stringify({ noop: 'noop' }),
    {
      metrics: {
        enabled: true,
        collectionNameId,
        collectionId,
      },
    }
  )
  return data
}

/* API request to unfollow a collection */
export async function unfollowCollectionRequest(
  collectionNameId,
  collectionId
) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/followers`,
    qs.stringify({ noop: 'noop' }),
    {
      metrics: {
        enabled: true,
        collectionNameId,
        collectionId,
      },
    }
  )
  return data
}

/* API request to subscribe the user to a collections mods */
export async function subscribeCollectionRequest(
  collectionNameId,
  collectionId
) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/subscriptions`,
    qs.stringify({ noop: 'noop' }),
    {
      metrics: {
        enabled: true,
        collectionNameId,
        collectionId,
      },
    }
  )
  return data
}

/* API request to unsubscribe the user to a collections mods */
export async function unsubscribeCollectionRequest(
  collectionNameId,
  collectionId
) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}/subscriptions`,
    qs.stringify({ noop: 'noop' }),
    {
      metrics: {
        enabled: true,
        collectionNameId,
        collectionId,
      },
    }
  )
  return data
}

/* API request to delete a collection */
export async function deleteCollectionRequest(
  collectionNameId,
  reason = '',
  permanent = false
) {
  const query = { reason }
  if (permanent) {
    query.permanent = true
  }
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/collections/@${collectionNameId}${queryString(query)}`
  )
  return data
}
